import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import BITextInput from "../../components/BITextInput";
import BIButton from "../../components/BIButton";
import { ForgotPasswordFormValues } from "./authInterface";
import { forgotPasswordSchema, loginSchema } from "./authDtos";
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from "react-toastify";
import { forgotPassword } from "./authQueries";
import { useLocation } from "react-router-dom";

const ForgotPasswordForm = () => {
    const location = useLocation();
    console.log(window.location.origin);
    const { control, handleSubmit, formState: {errors}, reset } = useForm<ForgotPasswordFormValues>({
		resolver: zodResolver(forgotPasswordSchema),
	});
    const { mutate:forgotPasswordMutation, isPending:isLoading } = useMutation({
        mutationKey: ['auth/forgot-password'],
        mutationFn: forgotPassword,
    });

    const onSubmit = (formValues: ForgotPasswordFormValues) => {
		formValues.email = formValues.email.trim();
        formValues.resetUrl= `${window.location.origin}/auth/reset-password`;

		forgotPasswordMutation(formValues, {
			onSuccess(data: any) {
                data = data.data;
				reset(); 
				toast.success('Kindly check your email for instructions on the next steps',{autoClose:false});
			},
			onError(error: any) {
                // console.log(error?.response?.data?.message)
				if (error?.response?.data?.message) {
					toast.error(error.response.data.message);
				}
                else{
                    toast.error('An error occurred please try again');
                }
			},
		});
	};

    return (
        <div className="w-full flex flex-col items-center">
            <p className="font-bold text-[24px] mb-[20px]">Forgot Password</p>
            <p className="mb-[60px]">Enter registered email for password reset link.</p>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full">
                <BITextInput
                    name="email"
                    control={control}
                    type="email"
                    placeholder="Enter your email"
                    label="Email"
                    rules={{ required: "Email is required" }}
                />
                <div className="mb-[60px]" />
                <BIButton text="Send link" type="submit" isLoading={isLoading}/>
            </form>
        </div>
    );
};

export default ForgotPasswordForm;
